<template>
  <v-container class="px-0">
    <v-row no-gutters>
      <v-col cols="12">
        <v-toolbar color="transparent primary--text" flat>
          <v-avatar color="primary">
            <v-icon color="white">mdi-folder</v-icon>
          </v-avatar>
          <v-toolbar-title class="font-weight-bold pl-2">
            {{ $tc('biblioteca') | capitalize }}
          </v-toolbar-title>
          <v-spacer/>
          <template>
            <v-btn icon color="primary" :disabled="materiales.cargando" @click="cargarMateriales()">
              <v-icon>mdi-refresh</v-icon>
            </v-btn>
          </template>
        </v-toolbar>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col>
        <div class="mt-4">
          <filtro-nombre-material :es-biblioteca="true" @actualizado="filtroNombreActualizado"/>
        </div>
      </v-col>
    </v-row>

    <v-row no-gutters>
      <v-col>
        <div class="mt-4">
          <filtro-menu-material v-model="filtros" :es-biblioteca="true" :solucion-constructiva="solucionConstructiva"
                                @actualizado="cargarMateriales"/>
        </div>
      </v-col>
    </v-row>

    <v-row no-gutters class="pt-4">
      <v-col cols="12" v-if="materiales.listado.length < 1 && !materiales.cargando">
        <v-alert class="primary--text" color="tertiary">
          <v-icon class="mr-2" color="primary">mdi-information</v-icon>
          {{ $t("no_hay_mat") }}
        </v-alert>
      </v-col>
      <v-col :cols="esMovil ? 12 : 3" v-for="k in (materiales.cargando ? 4 : 0)" :key="k" class="pa-2">
        <v-skeleton-loader ref="skeleton" type="image" class="mx-auto"/>
      </v-col>

      <v-col :cols="esMovil ? 12 : 3" v-for="(material,index) in (!materiales.cargando ? materiales.listado : [])"
             :key="index" class="pa-2">
        <modal-ver-material v-model="mostrarInfoMaterial" :material="materialSeleccionado"
                            @cerrado="mostrarInfoMaterial = false"/>
        <v-hover v-slot="{ hover }">
          <v-card :class="[ hover ? 'secondary' : '']" outlined @click="verMaterial(material)">
            <div class="pa-4">
              <v-img height="130" :src="material.imagen" contain position="right" content-class="py-5">
                <v-card-title class="primary--text body-2 pt-0">
                  {{ material.marca }}
                </v-card-title>
                <v-card-subtitle class="primary--text subtitle-1">
                  <descripcion-mat-pers-cmp :material="material"/>
                </v-card-subtitle>
                <v-card-text class="pa-0">&nbsp;</v-card-text>
              </v-img>
            </div>
          </v-card>
        </v-hover>
      </v-col>
    </v-row>

    <v-row no-gutters v-show="materiales.paginas > 0">
      <v-col cols="12">
        <div class="text-center">
          <v-pagination circle v-model="materiales.pagina" :length="materiales.paginas"
                        :disabled="materiales.cargando"/>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import FiltroNombreMaterial from "@/components/FiltroNombreMaterial";
import FiltroMenuMaterial from "@/components/FiltroMenuMaterial";
import ModalVerMaterial from "@/components/ModalVerMaterial";
import {HttpHelper} from "@/comunes/helpers/HttpHelper";
import DescripcionMatPersCmp from "@/components/DescripcionMatPersCmp";

export default {
  name: "BibliotecaPagina",
  components: {
    DescripcionMatPersCmp,
    FiltroNombreMaterial,
    FiltroMenuMaterial,
    ModalVerMaterial
  },
  props: {
    filtradoMaterial: {type: Object, required: false, default: null},
    solucionConstructiva: {type: Object, required: false, default: null},
  },
  data() {
    return {
      busqueda: "",
      filtros: [],
      materiales: {
        listado: [],
        cargando: false,
        pagina: 1,
        porPagina: 15,
        paginas: 0
      },
      mostrarInfoMaterial: false,
      materialSeleccionado: {}
    }
  },
  mounted() {
    this.cargarMateriales();
  },
  methods: {
    filtroNombreActualizado(val) {
      this.busqueda = val
      this.cargarMateriales()
    },
    verMaterial(material) {
      this.materialSeleccionado = material
      this.mostrarInfoMaterial = true
    },
    cargarMateriales() {
      this.materiales.cargando = true;
      let params = {
        pagina: this.materiales.pagina - 1,
        porPagina: this.materiales.porPagina,
      };

      if (this.filtradoMaterial) params.materialFiltradoId = this.filtradoMaterial.id;
      if (this.busqueda && this.busqueda.length > 0) params.busqueda = this.busqueda;

      this.filtros.forEach((fil) => {
        if (fil.model.length > 0)
          params[fil.nombre] = fil.model.join(",");
      });

      HttpHelper.get('biblioteca-materiales/listado', params)
          .then((res) => {
            this.materiales.listado = res.content;
            this.materiales.paginas = res.totalPages;
          })
          .finally(() => {
            this.materiales.cargando = false;
          });
    },
  },
  computed: {
    esMovil() {
      return this.$vuetify.breakpoint.smAndDown;
    }
  }
}
</script>

<style scoped>

</style>

<!--@formatter:off-->
<i18n>
{
  "es": {
    "biblioteca": "Biblioteca de materiales",
    "no_hay_mat": "No hay materiales"
  }
}
</i18n>
<!--@formatter:oon-->
